import {
  TERMINAL_MEMBER_BANK_FETCH_REQUEST,
  TERMINAL_MEMBER_BANK_FETCH_REQUEST_FAILURE,
  TERMINAL_MEMBER_BANK_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalMemberBankReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_MEMBER_BANK_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_MEMBER_BANK_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_MEMBER_BANK_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default terminalMemberBankReducer;
